import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Card, Modal } from 'react-bootstrap';

import { getAge } from 'lib/utils/dateUtils';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import pointerOnHover from 'lib/css/pointerOnHover';
import useGet from 'lib/hooks/useGet';
import { UserNotificationTypeLabels } from 'lib/enums/UserNotificationEnums';
import { USER_GET_ALL_NOTIFICATIONS } from 'lib/networking/endpoints';

function UserNotificationsModal({ show, handleClose }) {
  const { data: { notifications } = {}, loading } = useGet(USER_GET_ALL_NOTIFICATIONS, {});

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Notifications</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <LoadingSpinner />
        ) : (
          notifications?.map(notification => (
            <Card
              key={notification.id}
              className={classNames(pointerOnHover, 'mb-3')}
              onClick={() => window.open(notification.meta_data?.url, '_blank')}
            >
              <Card.Body>
                <div className="d-flex justify-content-between">
                  <strong>{UserNotificationTypeLabels[notification.notification_type]}</strong>
                  <span className="text-muted">{getAge(notification.date_created)}</span>
                </div>
                <div className="mt-2">
                  <Card.Text>{notification.meta_data?.description}</Card.Text>
                </div>
              </Card.Body>
            </Card>
          ))
        )}
      </Modal.Body>
    </Modal>
  );
}

UserNotificationsModal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default UserNotificationsModal;
